namespace Matrix.Rebalancer {
    export interface TradeMacroStepRow {
        MacroCode?: string;
        StepNo?: number;
        AccountCode?: string;
        SecurityOrAccountCode?: string;
        Weight?: number;
        Strategy?: string;
        CashAccount?: string;
        Contra?: boolean;
        BalanceWeights?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        MacroDescription?: string;
        MacroRowId?: number;
    }

    export namespace TradeMacroStepRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'MacroCode';
        export const localTextPrefix = 'Rebalancer.TradeMacroStep';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            MacroCode = "MacroCode",
            StepNo = "StepNo",
            AccountCode = "AccountCode",
            SecurityOrAccountCode = "SecurityOrAccountCode",
            Weight = "Weight",
            Strategy = "Strategy",
            CashAccount = "CashAccount",
            Contra = "Contra",
            BalanceWeights = "BalanceWeights",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            MacroDescription = "MacroDescription",
            MacroRowId = "MacroRowId"
        }
    }
}
